<button
	mat-raised-button
	[class.clicked]="active"
	(click)="toggleState($event)"
	[disabled]="disabled"
	[color]="color"
	[style.width.px]="width"
	[class.is-purple]="isPurple"
>
	<div class="cta-button-container">
		<div class="tags" *ngIf="tags && tags.length > 0">
			<div class="tag" *ngFor="let tag of tags">
				<img src="/assets/img/badge-dark-triangle.svg" />
				{{ tag }}
			</div>
		</div>
		<div
			class="image"
			[style.background-image]="'url(' + image + ')'"
			*ngIf="image"
		></div>
		<div class="icon-image" *ngIf="iconImage">
			<img [src]="iconImage" />
		</div>
		<div
			class="title"
			[class.bottom-margin]="titleMargin"
			*ngIf="!iconImage && (title || titleSuffix)"
		>
			<span class="title-suffix" *ngIf="titlePrefix">
				{{ titlePrefix }}
			</span>
			{{ title }}
			<span class="title-suffix" *ngIf="titleSuffix">
				{{ titleSuffix }}
			</span>
		</div>
		<div class="sub-title" *ngIf="subTitle">
			{{ subTitle }}
		</div>
		<div
			class="title"
			*ngIf="iconImage && !image && (title || titleSuffix)"
		>
			{{ title }}
			<span class="title-suffix" *ngIf="titleSuffix">
				{{ titleSuffix }}
			</span>
		</div>
		<div *ngIf="hasFinePrints" class="fine-prints">
			{{ finePrints || " " }}
		</div>
	</div>
</button>
<div *ngIf="!isPurple" [class.show]="active" class="border gradient-bg"></div>
